import { render, staticRenderFns } from "./VehiclesBrandCreateModal.vue?vue&type=template&id=63c069ae&scoped=true"
import script from "./VehiclesBrandCreateModal.vue?vue&type=script&lang=js"
export * from "./VehiclesBrandCreateModal.vue?vue&type=script&lang=js"
import style0 from "./VehiclesBrandCreateModal.vue?vue&type=style&index=0&id=63c069ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c069ae",
  null
  
)

export default component.exports